import {PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Customer } from '../../types/customer';

interface RootState {
  customers: Customer[];
  selectedOrganization: Customer | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: RootState = {
  customers: [],
  selectedOrganization: null,
  status: 'idle',
  error: null,
};


export const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomers: (state, action: PayloadAction<Customer[]>) => {
      state.customers = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    setSelectedOrganization: (state, action: PayloadAction<Customer | null>) => {
      state.selectedOrganization = action.payload;
    },
    customerAdd: (state, action: PayloadAction<Customer>) => {
      state.customers.push(action.payload);
      state.status = 'succeeded';
      state.error = null;
    },
    customerUpdate: (state, action: PayloadAction<Customer>) => {
      const index = state.customers.findIndex((c) => c.id === action.payload.id);
      if (index !== -1) {
        state.customers[index] = action.payload;
      }
      state.status = 'succeeded';
      state.error = null;
    },
    setLoading: (state) => {
      state.status = 'loading';
      state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.status = 'failed';
      state.error = action.payload;
    },
  },
  
});

export const { setCustomers, setSelectedOrganization,customerAdd,customerUpdate , setLoading, setError } = customerSlice.actions;

export default customerSlice.reducer;
